// extracted by mini-css-extract-plugin
module.exports = {"card-block-list":"acf-card-block_card-block-list__jed0I"};